import { useMemo } from 'react';
import { useGetInsurancePayrollMovements } from '@/common/integrations/menhir/employee/insurance/insurance.hooks';
import { IInsuranceMovement } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { useGetMovementsData } from '@/common/integrations/menhir/employee/movements/movements.hooks';
import { IInsuranceOrder } from '@/common/types/catalog';

export function useInsuranceMovements(policyId?: string) {
  const { movements: walletMovements, isInitialLoading: isLoadingWallet } =
    useGetMovementsData(
      {
        category: 'health',
      },
      { enabled: !!policyId }
    );

  const { payrollMovements, isInitialLoading: isLoadingPayroll } =
    useGetInsurancePayrollMovements(policyId!, {
      enabled: !!policyId,
    });

  const mergedMovements = useMemo(() => {
    return walletMovements?.list
      .map<IInsuranceMovement>((movement) => ({
        id: movement.id,
        amount: movement.amount,
        date: movement.executedAt,
        memberShortName: (movement.order as IInsuranceOrder).coveredPerson
          .shortName,
        type: 'wallet',
      }))
      .concat(
        payrollMovements?.map<IInsuranceMovement>((movement) => ({
          id: movement.id,
          amount: movement.amount,
          date: movement.paidAt,
          memberShortName: movement.coveredPerson.shortName,
          type: 'payroll',
        })) ?? []
      );
  }, [walletMovements, payrollMovements]);

  return {
    walletMovements: walletMovements?.list,
    payrollMovements,
    mergedMovements,
    isLoading: isLoadingWallet || isLoadingPayroll,
  };
}
